import { Button } from "@mui/material";
import { Link } from "react-router";

interface Props {
  title: string;
  link: string;
  highlighted?: boolean;
}

const PageLink = ({ title, link, highlighted }: Props) => {
  return (
    <Button
      component={Link}
      to={link}
      state={{ refresh: true }}
      sx={{
        px: 2,
        color: "inherit",
        textTransform: "none",
        fontWeight: highlighted ? "bold" : "normal",
      }}
    >
      {title}
    </Button>
  );
};

export default PageLink;
